import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import './PageStepper.css';

import { eventTypes, trackEvent } from '../../helpers/AnalyticsManager';

import PrevButtonImg from '../../images/publications/prev-button.png';
import NextButtonImg from '../../images/publications/next-button.png';
import PrevButtonDisabledImg from '../../images/publications/prev-button-disabled.png';
import NextButtonDisabledImg from '../../images/publications/next-button-disabled.png';

function pageSteppers(currentPage, numberPages) {
  let steppers = [currentPage - 1, currentPage, currentPage + 1];

  if (currentPage === 1) {
    steppers.shift();
  }

  if (currentPage === numberPages) {
    steppers.pop();
  }

  if (steppers[0] > 1) {
    steppers = [1, '...', ...steppers];
  }

  if (steppers[steppers.length - 1] < numberPages) {
    steppers = [...steppers, '...', numberPages];
  }

  return steppers;
}

class PageStepper extends Component {
  constructor() {
    super();

    this.previousPage = this.previousPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.goToPage = this.goToPage.bind(this);
  }

  nextPage() {
    const { totalPages, currentPage } = this.props;
    const nextPage = currentPage + 1;

    if (nextPage < totalPages) {
      this.loadPage(nextPage);

      trackEvent(eventTypes.publicationStepper, {
        label: 'next',
        value: nextPage + 1,
      });
    }
  }

  previousPage() {
    const { currentPage } = this.props;
    const previousPage = currentPage - 1;

    if (previousPage >= 0) {
      this.loadPage(previousPage);

      trackEvent(eventTypes.publicationStepper, {
        label: 'previous',
        value: previousPage + 1,
      });
    }
  }

  goToPage(pageNumber) {
    trackEvent(eventTypes.publicationStepper, {
      label: 'page_number',
      value: pageNumber + 1,
    });
    this.loadPage(pageNumber);
  }

  loadPage(pageNumber) {
    const { goToPage } = this.props;
    goToPage(pageNumber);
  }

  render() {
    const { totalPages, currentPage } = this.props;

    const previousStepperDisabled = (totalPages > 1 && currentPage !== 0) ? '' : 'inactiveStepper notInteractive';
    const nextStepperDisabled = (totalPages > 1 && currentPage !== totalPages - 1) ? '' : 'inactiveStepper notInteractive';

    return (
      <div id="steppers">
        <button
          id="stepBack"
          className={`stepper ${previousStepperDisabled}`}
          type="submit"
          onClick={this.previousPage}
        >
          <img
            src={previousStepperDisabled ? PrevButtonDisabledImg : PrevButtonImg}
            alt="arrow pointing to left"
          />
          <p>Prev.</p>
        </button>

        <div id="pageCounter">
          <MediaQuery query="(min-width: 425px)">
            {
              pageSteppers(currentPage + 1, totalPages).map((stepper, index) => (
                <button
                  id={stepper === currentPage + 1 ? 'currentPage' : ''}
                  className={`stepper${stepper === '...' ? ' notInteractive' : ''}`}
                  type="submit"
                  key={index} // eslint-disable-line react/no-array-index-key
                  onClick={() => this.goToPage(stepper - 1)}
                >
                  <p>{stepper}</p>
                </button>
              ))
            }
          </MediaQuery>
          <MediaQuery query="(max-width: 425px)">
            <button
              className="stepper"
              type="submit"
              id="currentPage"
              onClick={() => this.goToPage(currentPage)}
            >
              <p>{currentPage + 1}</p>
            </button>
          </MediaQuery>
        </div>

        <button
          id="stepForward"
          className={`stepper ${nextStepperDisabled}`}
          type="submit"
          onClick={this.nextPage}
        >
          <p>Next</p>
          <img
            src={nextStepperDisabled ? NextButtonDisabledImg : NextButtonImg}
            alt="arrow pointing to right"
          />
        </button>
      </div>
    );
  }
}

PageStepper.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  goToPage: PropTypes.func.isRequired,
};

export default PageStepper;
